module.exports = __webpack_public_path__ + "img/exercise.411e27ed.png";